/**
 * Счётчик открытых запросов на вкладке браузера: «(11) Доска · Sync Tracker» в заголовке
 * и красный кружок с числом на иконке. Видно, даже когда вкладка не активна.
 */
import { onScopeDispose, ref, watch, type Ref } from 'vue';

/** Заголовок страницы без счётчика — его ставит роутер. */
export const baseTitle = ref(document.title);

const FAVICON = '/favicon.svg';
let icon: HTMLImageElement | null = null;

function link(): HTMLLinkElement {
  let el = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!el) {
    el = document.createElement('link');
    el.rel = 'icon';
    document.head.appendChild(el);
  }
  return el;
}

function drawFavicon(count: number) {
  const el = link();
  if (!count) {
    el.type = 'image/svg+xml';
    el.href = FAVICON;
    return;
  }
  const paint = () => {
    const size = 64;
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = size;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.drawImage(icon!, 0, 0, size, size);
    const text = count > 99 ? '99+' : String(count);
    ctx.font = `bold ${text.length > 2 ? 26 : 34}px system-ui, sans-serif`;
    const w = Math.max(38, ctx.measureText(text).width + 14);
    const h = 38;
    const x = size - w;
    ctx.fillStyle = '#ef4444';
    ctx.beginPath();
    ctx.roundRect(x, 0, w, h, h / 2);
    ctx.fill();
    ctx.fillStyle = '#fff';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, x + w / 2, h / 2 + 2);
    el.type = 'image/png';
    el.href = canvas.toDataURL('image/png');
  };
  if (icon?.complete) return paint();
  icon = new Image();
  icon.onload = paint;
  icon.src = FAVICON;
}

export function useTabBadge(count: Ref<number>) {
  watch(
    [count, baseTitle],
    ([n, title]) => {
      document.title = n ? `(${n}) ${title}` : title;
      drawFavicon(n);
    },
    { immediate: true },
  );
  // выход из приложения (экран входа) — без счётчика
  onScopeDispose(() => {
    document.title = baseTitle.value;
    drawFavicon(0);
  });
}
